import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { InfrastructureFeedbackRoutingModule } from './infrastructure-feedback-routing.module';
import { InfrastructureFeedbackListComponent } from './infrastructure-feedback-list/infrastructure-feedback-list.component';
import { InfrastructureFeedbackViewComponent } from './infrastructure-feedback-view/infrastructure-feedback-view.component';

@NgModule({
  declarations: [InfrastructureFeedbackListComponent, InfrastructureFeedbackViewComponent],
  imports: [
    CommonModule,
    InfrastructureFeedbackRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class InfrastructureFeedbackModule { }
